import SchemaComment from '~/scripts/services/model/schema-comment';
import _ from 'lodash-es';
import $ from 'jquery';

export default class ClassDesignerCommentEditorController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} NodeService
	 * @param {any} Notification
	 */
	constructor(
		$scope,
		$timeout,
		$translate,
		NodeService,
		Notification,
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.NodeService = NodeService;
		this.Notification = Notification;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/components/class-designer/editor/class-designer-editor.controller').default} */
		this.editor = null;

		/** @type {?(import('angular').IFormController)} */
		this.form = null;

		/** @type {?SchemaComment} */
		this.schemaComment = null;

		/**
		 * @type {?{
		 *   modified: boolean,
		 *   node: SchemaComment,
		 *   options: ?import('~/scripts/services/model/class-designer').DesignerPanelOptions
		 * }}
		 */
		this.selected = null;

		/** @type {string} */
		this.tab = 'info';

		/** @type {?string} */
		this.title = null;

		/** @type {any} */
		this.tmp = {
			autoLinks: false,
			autoNodes: false,
			kdata:     {},
			validate:  true,
		};
	}

	async cancel() {
		if (this.editor?.tab) {
			if (this.schemaComment) {
				// @ts-ignore
				await this.editor.tab.commentDelete(this.schemaComment, this.selected[0].modified);
			}
			if (this.editor.tab.selected.length > 0 && this.selected) {
				this.editor.tab.unselectAll();
			}
		}
		this.selected = null;
		this.schemaComment = null;
	}

	async submit() {
		if (this.editor?.tab && this.schemaComment) {
			await this.editor.tab.commentUpdate(this.schemaComment);
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.selected) {
			this.schemaComment = this.selected ? _.cloneDeep(this.selected.node) : null;

			this.$timeout(async () => {
				$('class-designer-comment-editor textarea').trigger('focus');
			});
		}
	}

	$onInit() {
		this.$scope.$watch('$ctrl.form.$dirty', () => {
			if (this.selected && this.form) {
				this.selected.modified = this.form.$dirty;
			}
		});

		this.$scope.$on('admin-class-designer-submit-node', () => this.submit());
	}
}
